<template>
	<div class="analytics-popup-content">
		<!-- Close button -->
		<button class="close-btn" @click="onClose">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_155_8518)">
					<path
						d="M24 19.3131C24 19.8519 23.8114 20.3098 23.4343 20.6869L20.6869 23.4343C20.3098 23.8114 19.8519 24 19.3131 24C18.7744 24 18.3165 23.8114 17.9394 23.4343L12 17.4949L6.06061 23.4343C5.6835 23.8114 5.22559 24 4.68687 24C4.14815 24 3.69024 23.8114 3.31313 23.4343L0.565657 20.6869C0.188552 20.3098 0 19.8519 0 19.3131C0 18.7744 0.188552 18.3165 0.565657 17.9394L6.50505 12L0.565657 6.06061C0.188552 5.6835 0 5.22559 0 4.68687C0 4.14815 0.188552 3.69024 0.565657 3.31313L3.31313 0.565657C3.69024 0.188552 4.14815 0 4.68687 0C5.22559 0 5.6835 0.188552 6.06061 0.565657L12 6.50505L17.9394 0.565657C18.3165 0.188552 18.7744 0 19.3131 0C19.8519 0 20.3098 0.188552 20.6869 0.565657L23.4343 3.31313C23.8114 3.69024 24 4.14815 24 4.68687C24 5.22559 23.8114 5.6835 23.4343 6.06061L17.4949 12L23.4343 17.9394C23.8114 18.3165 24 18.7744 24 19.3131Z"
						fill="#4499C5"
					/>
				</g>
				<defs>
					<clipPath id="clip0_155_8518">
						<rect width="24" height="24" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</button>

		<!-- Header with gradient background -->
		<div class="analytics-popup-header">
			<img src="/my/images/analytics-popup-top-header.svg" alt="Analytics Popup Top Header">
		</div>

		<!-- Main content -->
		<div class="analytics-popup-body">
			<div class="analytics-popup-title-section">
				<h1 class="analytics-popup-title" v-html="$t('modals.AnalyticsPopup.title')" />
			</div>

			<div class="analytics-popup-features">
				<p class="feature-text">
					{{ $tc('modals.AnalyticsPopup.features.trackEveryPlay') }}
				</p>
				<p class="feature-text">
					{{ $tc('modals.AnalyticsPopup.features.monitorEveryPlayer') }}
				</p>
				<p class="feature-text" v-html="$t('modals.AnalyticsPopup.features.getInsightsToWin')" />
			</div>

			<div class="analytics-popup-checkbox">
				<label class="checkbox-container">
					<input v-model="dontShowAgain" type="checkbox" class="checkbox-input">
					<div class="checkbox-custom" />
					<span class="checkbox-label">{{ $tc('modals.AnalyticsPopup.dontShowAgain') }}</span>
				</label>
			</div>
		</div>

		<!-- Action button -->
		<div class="analytics-popup-actions">
			<button class="learn-more-btn" @click="onLearnMore">
				{{ $tc('modals.AnalyticsPopup.learnMore') }}
			</button>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { ModalMixin } from '~/assets/vue/mixins'
import { createRedirectRoute } from '~/assets/util/redirect'

export default {
	name: 'ModalAnalyticsPopup',
	mixins: [ModalMixin],
	data () {
		return {
			dontShowAgain: false
		}
	},
	methods: {
		...mapActions({ analyticsTrack: 'analytics/track' }),
		onLearnMore () {
			// Track analytics event
			this.analyticsTrack({
				event: 'Analytics Popup Learn More Clicked',
				data: {
					source: 'analytics-campaign',
					action: 'learn-more',
					dontShowAgain: this.dontShowAgain
				}
			})

			// Redirect to analytics page using createRedirectRoute
			const redirectRoute = createRedirectRoute('analytics-campaign', 'learn-more')
			const redirectUrl = this.$router.resolve(redirectRoute).href

			window.open(redirectUrl, '_blank')
			this.onClose()
		},

		async onClose () {
			// Track analytics event
			this.analyticsTrack({
				event: 'Analytics Popup Closed',
				data: {
					dontShowAgain: this.dontShowAgain,
					method: this.dontShowAgain ? 'dont_show_again' : 'close_button'
				}
			})

			// Save the preference based on checkbox state
			if (this.dontShowAgain) {
				// Use action to save preference and update server
				await this.$store.dispatch('analytics-popup/markAnalyticsPopupAsShown')
			} else {
				// Just commit that it was shown for this session
				this.$store.commit('analytics-popup/setAnalyticsPopupShown', true)
			}

			// Call parent close method
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss">
$analytics-blue: #008fbe;
$analytics-blue-hover: #0070a3;
$analytics-light-blue: #a5d6ed;

.close-btn {
	position: absolute;
	top: 17px;
	right: 12px;
	width: 24px;
	height: 24px;
	background: none;
	border: none;
	cursor: pointer;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;
	color: $analytics-blue;
	opacity: 1;
	transition: opacity 0.2s ease;

	svg {
		width: 24px;
		height: 24px;
	}
}

.close-btn:hover {
	opacity: 1;
}

.analytics-popup-content {
	position: relative;
	width: 543px;
	background-color: $black;
	border-radius: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	padding-top: 105px;
	padding-bottom: 48px;
	padding-left: 32px;
	padding-right: 32px;
	gap: 48px;
}

.analytics-popup-header {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 105px;
	overflow: hidden;
	padding-left: 34px;
}

.analytics-popup-body {
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.analytics-popup-title-section {
	display: flex;
	flex-direction: column;
	gap: 32px;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
}

.analytics-popup-title {
	font-family: 'Inter', sans-serif;
	font-weight: 900;
	font-size: 32px;
	line-height: normal;
	color: $white;
	text-transform: uppercase;
	margin: 0;
	letter-spacing: 0;
}

.highlight-text {
	color: $analytics-blue;
}

.analytics-popup-features {
	display: flex;
	flex-direction: column;
	gap: 7px;
	font-family: 'Inter', sans-serif;
	font-weight: 700;
}

.feature-text {
	font-family: 'Inter', sans-serif;
	font-weight: 700;
	font-size: 26px;
	line-height: normal;
	color: $white;
	margin: 0;
	width: 504px;
}

.analytics-popup-checkbox {
	display: flex;
	gap: 12px;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
}

.checkbox-container {
	display: flex;
	align-items: center;
	gap: 12px;
	cursor: pointer;
}

.checkbox-container:hover .checkbox-custom {
	border-color: $analytics-blue;
}

.checkbox-input {
	opacity: 0;
	position: absolute;
	pointer-events: none;
	width: 18px;
	height: 18px;
	margin: 0;
}

.checkbox-custom {
	width: 18px;
	height: 18px;
	border: 1px solid $analytics-light-blue;
	border-radius: 4px;
	background-color: transparent;
	position: relative;
	flex-shrink: 0;
}

.checkbox-custom::after {
	content: '';
	position: absolute;
	left: 5px;
	top: 1px;
	width: 6px;
	height: 10px;
	border: solid $white;
	border-width: 0 2px 2px 0;
	transform: rotate(45deg);
	opacity: 0;
	transition: opacity 0.2s ease;
}

.checkbox-input:checked+.checkbox-custom {
	background-color: $analytics-blue;
	border-color: $analytics-blue;
}

.checkbox-input:checked+.checkbox-custom::after {
	opacity: 1;
}

.checkbox-label {
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: normal;
	color: rgba(255, 255, 255, 0.5);
	white-space: pre;
}

.analytics-popup-actions {
	display: flex;
	gap: 22px;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
}

.learn-more-btn {
	flex: 1;
	height: 44px;
	background-color: $analytics-blue;
	border: none;
	border-radius: 24px;
	color: $white;
	font-family: 'Inter', sans-serif;
	font-weight: 700;
	font-size: 16px;
	line-height: normal;
	cursor: pointer;
	transition: background-color 0.2s ease;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

.learn-more-btn:hover {
	background-color: $analytics-blue-hover;
}

.learn-more-btn:active {
	transform: translateY(1px);
}

/* Responsive design */
@media (max-width: 600px) {
	.analytics-popup-header {
		padding-left: 14px;
		margin-top: -16px;
	}

	.analytics-popup-content {
		width: 90vw;
		max-width: 500px;
		padding-left: 24px;
		padding-right: 24px;
	}

	.gradient-decoration {
		width: 400px;
		height: 90px;
		top: -45px;
		left: 20px;
	}

	.analytics-popup-title {
		font-size: 28px;
	}

	.feature-text {
		font-size: 22px;
		width: auto;
	}

	.close-btn {
		right: 8px;
	}
}

@media (max-width: 480px) {
	.analytics-popup-content {
		width: 95vw;
		max-width: 400px;
		padding-left: 20px;
		padding-right: 20px;
		padding-top: 80px;
		gap: 32px;
	}

	.analytics-popup-header {
		height: 80px;
	}

	.gradient-decoration {
		width: 300px;
		height: 70px;
		top: -35px;
		left: 15px;
	}

	.analytics-popup-title {
		font-size: 24px;
	}

	.feature-text {
		font-size: 20px;
	}

	.close-btn {
		right: 8px;
		top: 12px;
	}
}
</style>
